import http from "./http-common";

class ApiData {
  getorganization() {
    return http.get("/get/organization/group");
  }
  getknowledge() {
    return http.get("/get/knowledge/groups");
  }
  getimpact() {
    return http.get("get/impact/groups");
  }
  getgoal() {
    return http.get("/get/goal/group");
  }

  getknowledgeMap(university, knowledge, impact, goal) {
    return http.get(
      `/get/knowledge/visualize-map?university=${university}&knowledgegroup=${knowledge}&impact=${impact}&goal=${goal}`
    );
  }

  getgoalMap(university, knowledge, impact, goal) {
    return http.get(
      `/get/goal/visualize-map?university=${university}&knowledgegroup=${knowledge}&impact=${impact}&goal=${goal}`
    );
  }

  getimpactMap(university, knowledge, impact, goal) {
    return http.get(
      `/get/impact/visualize-map?university=${university}&knowledgegroup=${knowledge}&impact=${impact}&goal=${goal}`
    );
  }

  getnewknowledgeMap(university, knowledge, impact, goal) {
    return http.get(
      `/get/new-knowledge/visualize-map?university=${university}&knowledgegroup=${knowledge}&impact=${impact}&goal=${goal}`
    );
  }
}

export default new ApiData();
